import { genId } from "@smartsheet/lodestar-utils";
export var GROW_WRAPPER_CLASS = genId("textarea-grow-wrapper");
//# sourceMappingURL=constants.js.map